module.exports = __webpack_public_path__ + "img/14_31.358b6421.png";